<template>
  <div>
    <div class="_3Xkbf1q98zid75JkEX0FDf">
      <div class="_2xuZ-gLMq42ggV4fOmVnHB container">
        <h1 style="text-align: left;padding-top: 120px;font-weight: normal;">获得湖北省版权局官方证书</h1>
        <p style="text-align: left;">
          <span>快速下证</span>
          <span>交易无忧</span>
          <span>安全省心</span>
          <span>官方权威</span>
        </p>
        <div style="text-align: left">
          <button
            type="button"
            class="ant-btn ant-btn-primary ant-btn-lg"
            style="margin-top: 40px"
          >
          <router-link to="/Register/InputForm">立即登记</router-link>
          </button>
        </div>
      </div>
    </div>
    <ul>
      <li class="_26r1pZ3wpM5vFO1ZwldTf9 flagBack2">
        <div class="_1PhwEURvn4aBO3Ywu1xaVx">
          <h1>可登记的作品类型</h1>
          <p
            style="
              text-align: center;
              color: #475663;
              padding: 20px 0 40px 0;
              font-size: 14px;
              font-family: PingFangSC-Regular;
            "
          >
            数字作品版权所涉猎作品均可登记，全品类包含九大类型
          </p>
          <div style="display: flex; justify-content: space-between; align-items: center;margin-bottom: 40px;">
            <div
              style="width: 320px;height: 186px;text-align: center;border-radius: 5px;box-shadow: 0px 0px 12px 0px rgba(38, 89, 200, 0.13);background: #fff;padding: 0 30px;"
            >
              <img
                src="../../../assets/images/show21.png"
                style="width: 90px; height: 90px"
              />
              <div style="padding: 0px 5px; flex: 1 1 0%">
                <h2 style="margin-bottom: 5px;font-size: 18px;color: #000;">文字作品</h2>
                <p style="font-size: 14px;color: #475663;font-family: PingFangSC-Regular;">小说、论文、剧本商业计划书、歌词等；</p>
              </div>
            </div>
            <div
              style="width: 320px;height: 186px;text-align: center;border-radius: 5px;box-shadow: 0px 0px 12px 0px rgba(38, 89, 200, 0.13);background: #fff;padding: 0 30px;"
            >
              <img
                src="../../../assets/images/show22.png"
                style="width: 90px; height: 90px"
              />
              <div style="padding: 0px 5px; flex: 1 1 0%">
                <h2 style="margin-bottom: 5px;font-size: 18px;color: #000;">摄影作品</h2>
                <p style="font-size: 14px;color: #475663;font-family: PingFangSC-Regular;">人像摄影、艺术摄影、商业摄影等；</p>
              </div>
            </div>
            <div
              style="width: 320px;height: 186px;text-align: center;border-radius: 5px;box-shadow: 0px 0px 12px 0px rgba(38, 89, 200, 0.13);background: #fff;padding: 0 30px;"
            >
              <img
                src="../../../assets/images/show23.png"
                style="width: 90px; height: 90px"
              />
              <div style="padding: 0px 5px; flex: 1 1 0%">
                <h2 style="margin-bottom: 5px;font-size: 18px;color: #000;">美术作品</h2>
                <p style="font-size: 14px;color: #475663;font-family: PingFangSC-Regular;">包装图、商标标识、效果图；漫画；雕塑等；</p>
              </div>
            </div>
          </div>
          <div style="display: flex; justify-content: space-between; align-items: center;margin-bottom: 40px;">
            <div
              style="width: 320px;height: 186px;text-align: center;border-radius: 5px;box-shadow: 0px 0px 12px 0px rgba(38, 89, 200, 0.13);background: #fff;padding: 0 30px;"
            >
              <img
                src="../../../assets/images/show24.png"
                style="width: 90px; height: 90px"
              />
              <div style="padding: 0px 5px; flex: 1 1 0%">
                <h2 style="margin-bottom: 5px;font-size: 18px;color: #000;">音乐作品</h2>
                <p style="font-size: 14px;color: #475663;font-family: PingFangSC-Regular;">词曲、器乐等；</p>
              </div>
            </div>
            <div
              style="width: 320px;height: 186px;text-align: center;border-radius: 5px;box-shadow: 0px 0px 12px 0px rgba(38, 89, 200, 0.13);background: #fff;padding: 0 30px;"
            >
              <img
                src="../../../assets/images/show25.png"
                style="width: 90px; height: 90px"
              />
              <div style="padding: 0px 5px; flex: 1 1 0%">
                <h2 style="margin-bottom: 5px;font-size: 18px;color: #000;">工程设计图、产品设计图</h2>
                <p style="font-size: 14px;color: #475663;font-family: PingFangSC-Regular;">平面设计图、施工图、工业设计图、服装设计图等；</p>
              </div>
            </div>
            <div
              style="width: 320px;height: 186px;text-align: center;border-radius: 5px;box-shadow: 0px 0px 12px 0px rgba(38, 89, 200, 0.13);background: #fff;padding: 0 30px;"
            >
              <img
                src="../../../assets/images/show26.png"
                style="width: 90px; height: 90px"
              />
              <div style="padding: 0px 5px; flex: 1 1 0%">
                <h2 style="margin-bottom: 5px;font-size: 18px;color: #000;">视听作品</h2>
                <p style="font-size: 14px;color: #475663;font-family: PingFangSC-Regular;">电影、短片、录像、短视频、电视剧、动画片等；</p>
              </div>
            </div>
          </div>
          <div style="display: flex; justify-content: space-between; align-items: center;margin-bottom: 40px;">
            <div
              style="width: 320px;height: 186px;text-align: center;border-radius: 5px;box-shadow: 0px 0px 12px 0px rgba(38, 89, 200, 0.13);background: #fff;padding: 0 30px;"
            >
              <img
                src="../../../assets/images/show27.png"
                style="width: 90px; height: 90px"
              />
              <div style="padding: 0px 5px; flex: 1 1 0%">
                <h2 style="margin-bottom: 5px;font-size: 18px;color: #000;">口述作品</h2>
                <p style="font-size: 14px;color: #475663;font-family: PingFangSC-Regular;">即兴演说、授课、法庭辩论等；</p>
              </div>
            </div>
            <div
              style="width: 320px;height: 186px;text-align: center;border-radius: 5px;box-shadow: 0px 0px 12px 0px rgba(38, 89, 200, 0.13);background: #fff;padding: 0 30px;"
            >
              <img
                src="../../../assets/images/show28.png"
                style="width: 90px; height: 90px"
              />
              <div style="padding: 0px 5px; flex: 1 1 0%">
                <h2 style="margin-bottom: 5px;font-size: 18px;color: #000;">戏剧作品</h2>
                <p style="font-size: 14px;color: #475663;font-family: PingFangSC-Regular;">话剧、歌剧、地方戏剧等；</p>
              </div>
            </div>
            <div
              style="width: 320px;height: 186px;text-align: center;border-radius: 5px;box-shadow: 0px 0px 12px 0px rgba(38, 89, 200, 0.13);background: #fff;padding: 0 30px;"
            >
              <img
                src="../../../assets/images/show29.png"
                style="width: 90px; height: 90px"
              />
              <div style="padding: 0px 5px; flex: 1 1 0%">
                <h2 style="margin-bottom: 5px;font-size: 18px;color: #000;">其他作品</h2>
                <p style="font-size: 14px;color: #475663;font-family: PingFangSC-Regular;">曲艺、舞蹈、杂技模型等符合作品特征的其他智力成果；</p>
              </div>
            </div>
          </div>
        </div>
      </li>
      <li class="_26r1pZ3wpM5vFO1ZwldTf9" style="background: #fff;">
        <div
          class="_1PhwEURvn4aBO3Ywu1xaVx container"
          style="display: flex; flex-direction: column; align-items: center"
        >
          <h1>版权局官方证书</h1>
          <!-- <p
            style="
              text-align: center;
              padding: 20px 0 0 0;
              font-size: 14px;color: #475663;
              font-family: PingFangSC-Regular;
            "
          >
            利用区块链技术,实现对作品创作时间和内容的快速存证,并即时生成存证证书,为维权提供强有力的证据
          </p> -->
          <div class="_1g6o3955RgNJaN8SByQGhv">
            <el-image
              class="img"
              :src="require('../../../assets/images/certificate2.png')"
              :preview-src-list="[require('../../../assets/images/certificate2.png')]"
              style="height: 100%;margin: 0 auto;"
            >
            </el-image>
          </div>
        </div>
      </li>
      <li class="_26r1pZ3wpM5vFO1ZwldTf9 flagBack flagBack3">
        <div class="_1PhwEURvn4aBO3Ywu1xaVx">
          <h1>版权登记流程</h1>
          <div
            style="display: flex; justify-content: center; align-items: center;position: relative;padding: 0 50px;margin-top: 40px;"
          >
            <img class="show-bg" src="../../../assets/images/show-bg.png" alt="" style="width: 100%;position: absolute;z-index: 0;margin-top: -55px;">
            <div style="flex: 1 1 0%; padding: 20px; text-align: center; z-index: 1;">
              <div>
                <img
                src="../../../assets/images/show05.png"
              />
              </div>
              <p>1</p>
              <h3 style="padding-top: 10px;font-size: 14px;color: #475663;font-family: PingFangSC-Regular;">平台注册</h3>
            </div>
            <!-- <img
              src="https://www.gzbqdj.com/7dc5d80740c1afe78f028c29b7e769f0.png"
            /> -->
            <div style="flex: 1 1 0%; padding: 20px; text-align: center; z-index: 1;">
              <div>
                <img
                src="../../../assets/images/show14.png"
              />
              </div>
              <p>2</p>
              <h3 style="padding-top: 10px;font-size: 14px;color: #475663;font-family: PingFangSC-Regular;">实名认证</h3>
            </div>
            <!-- <img
              src="https://www.gzbqdj.com/7dc5d80740c1afe78f028c29b7e769f0.png"
            /> -->
            <div style="flex: 1 1 0%; padding: 20px; text-align: center; z-index: 1;">
              <div>
                <img
                  src="../../../assets/images/show06.png"
                />
              </div>
              <p>3</p>
              <h3 style="padding-top: 10px;font-size: 14px;color: #475663;font-family: PingFangSC-Regular;">上传作品</h3>
            </div>
            <!-- <img
              src="https://www.gzbqdj.com/7dc5d80740c1afe78f028c29b7e769f0.png"
            /> -->
            <div style="flex: 1 1 0%; padding: 20px; text-align: center; z-index: 1;">
              <div>
                <img
                src="../../../assets/images/show13.png"
              />
              </div>
              <p>4</p>
              <h3 style="padding-top: 10px;font-size: 14px;color: #475663;font-family: PingFangSC-Regular;">等待审核</h3>
            </div>
            <!-- <img
              src="https://www.gzbqdj.com/7dc5d80740c1afe78f028c29b7e769f0.png"
            /> -->
            <div style="flex: 1 1 0%; padding: 20px; text-align: center; z-index: 1;">
              <div>
                <img
                src="../../../assets/images/show08.png"
              />
              </div>
              <p>5</p>
              <h3 style="padding-top: 10px;font-size: 14px;color: #475663;font-family: PingFangSC-Regular;">生成证书</h3>
            </div>
          </div>
        </div>
      </li>
      <li class="_26r1pZ3wpM5vFO1ZwldTf9" style="background: #fff;display: none;">
        <div class="_1PhwEURvn4aBO3Ywu1xaVx">
          <h1>湖北省版权登记平台登记代办服务收费标准</h1>
          <p
            style="
              text-align: center;
              padding: 20px 0 40px 0;
              font-size: 14px;color: #475663;
              font-family: PingFangSC-Regular;
            "
          >
            下述服务办理时限为资料提交完整，受理后次个工作日算起。
          </p>
          <table width="100%" class="_1We0tZUeXmBMXs1oK2z2H3">
            <tbody>
              <tr
                style="
                  background-color: #3377fe;
                  color: rgb(255, 255, 255);
                "
              >
                <th width="25%">服务项目</th>
                <th width="25%">收费标准</th>
                <th width="25%">办理时限</th>
                <th width="25%">备注</th>
              </tr>
              <tr>
                <td>版权登记代办（核发电子证书）</td>
                <td>
                  <p>50元/件</p>
                  <p>600元/件</p>
                  <p>1200元/件</p>
                  <p>2400元/件</p>
                </td>
                <td>
                  <p>10个工作日</p>
                  <p>5个工作日</p>
                  <p>3个工作日</p>
                  <p>1个工作日</p>
                </td>
                <td>
                  <p>正常</p>
                  <p>加急档</p>
                  <p>加急挡</p>
                  <p style="color: #3377fe">加急档</p>
                </td>
              </tr>
              <tr>
                <td>纸质证书打印</td>
                <td><p>20元/张</p></td>
                <td><p>5-7个工作日</p></td>
                <td><p>邮寄费自理，样品展示页2元/张</p></td>
              </tr>
              <tr>
                <td>证书信息变更代办</td>
                <td><p>50元/件</p></td>
                <td><p>5-7个工作日</p></td>
                <td></td>
              </tr>
              <tr>
                <td>档案查询代办</td>
                <td><p>50元/件</p></td>
                <td><p>10-15个工作日</p></td>
                <td>
                  <p>
                    资料打印费（A4纸）、刻录光盘按照1元/张收取，邮寄费自理。
                  </p>
                </td>
              </tr>
              <tr>
                <td>证书撤销代办</td>
                <td><p>50元/件</p></td>
                <td><p>10-15个工作日</p></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </li>
    </ul>
    <div style="padding: 50px 0;background: #fff;">
      <img src="../../../assets/images/support.png" style="display:block;margin: 0 auto;width: 300px;height: auto;" alt=""/>
    </div>
  </div>
</template>

<script>
export default {
  name: "RegisterShow",

  data() {
    return {};
  },

  methods: {},
};
</script>

<style scoped>
._3Xkbf1q98zid75JkEX0FDf {
    height: 460px;
    background: url(../../../assets/images/show-BannerBg.png);
    background-position: center center;
    padding: 20px 0;
}
._2xuZ-gLMq42ggV4fOmVnHB {
    width: 1160px;
    margin: 0 auto;
    color: #fff;
}
._2xuZ-gLMq42ggV4fOmVnHB h1 {
    font-size: 48px;
    /* letter-spacing: 4px; */
    color: #fff;
    padding-top: 150px;
    padding-bottom: 30px;
    text-align: center;
}
._2xuZ-gLMq42ggV4fOmVnHB h2 {
    font-size: 24px;
    color: #fafafa;
    letter-spacing: 2px;
    margin-bottom: 30px;
    margin-top: 40px;
    text-align: center;
}
._2xuZ-gLMq42ggV4fOmVnHB p {
    font-size: 20px;
    font-family: 'PingFang-SC-Regular';
    color: #fafafa;
    line-height: 32px;
    text-align: center;
}
._2xuZ-gLMq42ggV4fOmVnHB p span{
  position: relative;
  padding-left: 20px;
  margin-right: 20px;
}
._2xuZ-gLMq42ggV4fOmVnHB p span::before{
  position: absolute;
  content: '';
  width: 10px;
  height: 10px;
  border: 1px solid #fff;
  left: 0;
  top: 5px;
  border-radius: 50%;
}
.ant-btn {
    line-height: 1.5715;
    position: relative;
    display: inline-block;
    font-weight: 400;
    white-space: nowrap;
    text-align: center;
    background-image: none;
    border: 1px solid transparent;
    box-shadow: 0 2px 0 rgb(0 0 0 / 2%);
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    user-select: none;
    touch-action: manipulation;
    height: 32px;
    padding: 4px 15px;
    font-size: 14px;
    border-radius: 20px;
    color: rgba(0, 0, 0, 0.85);
    background: #fff;
    border-color: #d9d9d9;
}
.ant-btn-lg {
    height: 40px;
    padding: 6.4px 15px;
    font-size: 16px;
    border-radius: 20px;
}
.ant-btn-lg a{
    text-decoration: none;
}
.ant-btn-primary {
    color: #fff;
    background: #3377fe;
    border-color: #3377fe;
    text-shadow: 0 -1px 0 rgb(0 0 0 / 12%);
    box-shadow: 0 2px 0 rgb(0 0 0 / 5%);
}
.ant-btn > span {
    display: inline-block;
}
._26r1pZ3wpM5vFO1ZwldTf9 ._1PhwEURvn4aBO3Ywu1xaVx {
    width: 1160px;
    margin: 0 auto;
    padding: 60px 0;
}
.flagBack div div div div{
  width: 90px;
  height: 90px;
  border-radius: 50%;
  box-shadow: 0px 0px 12px 0px rgba(38, 89, 200, 0.13);
  padding: 20px;
  background: #fff;
  margin: 0 auto;
}
.flagBack div div div div img{
  width: 100%;
  height: 100%;
}
 .flagBack div div div p{
  font-size: 14px;
  color: #8f8f8f;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  margin: 10px auto 0 auto;
  border: 1px solid #8f8f8f;
  border-radius: 50%;
}
._26r1pZ3wpM5vFO1ZwldTf9 h1 {
    text-align: center;
    font-size: 28px;
    color: #333;
}
._1g6o3955RgNJaN8SByQGhv {
    width: 1135px;
    height: 389px;
    /* background: url(../../../assets/images/certificate2.png)no-repeat center; */
    background-size: contain;
    margin-top: 20px;
    text-align: center;
}
img {
    vertical-align: middle;
    border-style: none;
}
._1We0tZUeXmBMXs1oK2z2H3 {
    background-color: #fff;
    font-size: 15px;
    font-weight: bolder;
}
._1We0tZUeXmBMXs1oK2z2H3 td, ._1We0tZUeXmBMXs1oK2z2H3 th {
    border: 1px solid #eee;
    text-align: center;
    padding: 20px;
}

.flagBack,.flagBack2{
  background: #F4F7FC;
}


@media screen and (max-width: 991px) {
  ._2xuZ-gLMq42ggV4fOmVnHB{width: 100%;}
  ._2xuZ-gLMq42ggV4fOmVnHB h1{font-size: 32px;padding-top: 80px!important;}
  ._26r1pZ3wpM5vFO1ZwldTf9 ._1PhwEURvn4aBO3Ywu1xaVx{width: 100%;padding: 60px 16px;}
  ._1PhwEURvn4aBO3Ywu1xaVx div{display: block!important;margin: 0 auto;margin-bottom: 10px;}
  /* ._26r1pZ3wpM5vFO1ZwldTf9 ._1PhwEURvn4aBO3Ywu1xaVx{padding: 40px 16x!important;} */
  ._1g6o3955RgNJaN8SByQGhv{width: 100%;}
  .flagBack3 .show-bg{display: none;}
}

</style>